import { Wallet } from "lucide-react";
import { InspirationTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { useInspirationCtas } from "web_myplann/Inspiration/Hooks/useInspirationCtas";
import { useOpenGoalFormFromInspiration } from "web_myplann/Inspiration/Hooks/useOpenGoalFormFromInspiration";
import { RETIREMENT_GOAL_CATEGORY } from "web_myplann/Inspiration/Retirement/constants";
import { useRetirementGoalRecap } from "web_myplann/Inspiration/Retirement/Hooks/useRetirementGoalRecap";
import { mapRetirementGoalPreset } from "web_myplann/Inspiration/Retirement/Mappers/mapRetirementGoalPreset";
import type { RetirementContext } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

const R = Resources.Inspiration.Retirement;

type Params = {
	context: RetirementContext;
	onStart: () => void;
};

export const useRetirementCtas = ({ context, onStart }: Params) => {
	const { t } = useResource();
	const { openGoalForm } = useOpenGoalFormFromInspiration();
	const goalRecap = useRetirementGoalRecap(context);

	const createGoal = () => {
		const preset = mapRetirementGoalPreset(context);
		openGoalForm(
			{
				category: RETIREMENT_GOAL_CATEGORY,
				name: t(R.goalName),
				monthlyRent: preset.monthlyRent,
				statePension: preset.statePension,
				rentYears: preset.rentYears,
				drawdownMode: preset.drawdownMode,
				dueDate: preset.dueDate,
			},
			InspirationTypeEnum.Retirement,
		);
	};

	return useInspirationCtas({
		isCold: context.level === "cold",
		coldCta: { label: t(R.cta), icon: Wallet, onClick: onStart },
		goalRecap,
		createGoal: context.isCoveredByState
			? undefined
			: { label: t(R.createGoal), onClick: createGoal },
		advisor: { label: t(R.discussAdvisor), message: t(R.advisorMessage) },
	});
};
